import { motion } from "framer-motion";
import AnimatedSection from "@/components/layout/AnimatedSection";
import { differentials, fadeUp } from "@/data/site";

const Differentials = () => {
  return (
    <AnimatedSection id="diferenciais" className="section-padding bg-[#234D89]">
      <div className="container-custom">
        <motion.div variants={fadeUp} className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-4 block">
            Por que escolher a Finegraf?
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4">
            Nossos Diferenciais
          </h2>
          <div className="section-divider mx-auto" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {differentials.map((item, index) => (
            <motion.div
              key={item.title}
              variants={fadeUp}
              custom={index}
              whileHover={{ y: -8, scale: 1.02 }}
              data-testid={`differential-card-${index}`}
              className="differential-card p-8 rounded-2xl text-center group cursor-pointer"
            >
              <motion.div
                whileHover={{ rotate: 10 }}
                className="w-16 h-16 bg-gradient-to-br from-[#E73336] to-[#BD2A2C] rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-lg shadow-[#E73336]/20"
              >
                <item.icon size={28} weight="fill" className="text-white" />
              </motion.div>
              <h3 className="text-lg font-bold text-white mb-2">
                {item.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Differentials;
